










































import { Component, Emit, Prop, Vue } from "vue-property-decorator";

@Component
export default class AppBarButtons extends Vue {
  @Prop({ type: Boolean, default: true })
  isShow!: boolean;

  @Prop({ type: Boolean })
  isCameraOn!: boolean;

  @Prop({ type: Boolean })
  isCameraAvailable!: boolean;

  @Prop({ type: Boolean })
  isMicrophoneOn!: boolean;

  get tooltipText() {
    if (!this.isCameraAvailable) {
      return "Camera not available";
    }
    return this.isCameraOn ? "Disable video" : "Enable video";
  }

  @Emit()
  toggleCamera() {
    return !this.isCameraOn;
  }

  @Emit()
  toggleMicrophone() {
    return !this.isMicrophoneOn;
  }
}
